/*
 * STEEL Shipping Protection rules, shared by the cart page (assets/cart-page.js) and Buy Now
 * (assets/app.js.liquid). On the cart page the tier products and prices come from
 * snippets/shipping-protection-config.liquid; elsewhere loadTierFor(cart) fetches the one tier needed.
 *
 * SteelProtection.plan(cart, qtyByKey, want) returns the extra /cart/update.js `updates` and
 * `attributes` that make Shipping Protection match the cart after the given quantity changes.
 */
(function () {
  'use strict';
  if (window.SteelProtection) return;

  var PREFIX = 'shipping-protection-';
  var OPT_IN_KEY = 'shipping_protection_opt_in';
  // Carts holding only one of these (and nothing else) get no protection; same rule as sections/cart-template.liquid
  var NO_PROTECTION_HANDLES = ['gift-card-3', 'gift-box'];
  var config = null;

  function getConfig() {
    if (config) return config;
    var el = document.getElementById('ship-insur-data');
    try { config = el ? (JSON.parse(el.textContent).protectionConfig || {}) : {}; } catch (e) { config = {}; }
    return config;
  }

  function isProtection(item) {
    return !!(item && item.handle && item.handle.indexOf(PREFIX) === 0);
  }

  function requiredHandle(subtotal) {
    if (subtotal <= 2000) return 'shipping-protection-1';
    if (subtotal <= 5000) return 'shipping-protection-2';
    if (subtotal <= 10000) return 'shipping-protection-3';
    if (subtotal <= 15000) return 'shipping-protection-4';
    if (subtotal <= 20000) return 'shipping-protection-5';
    return 'shipping-protection-6';
  }

  // The shopper's choice: the cart's own attribute wins (it follows the cart across devices),
  // then this browser's saved choice, then opted in.
  function optedIn(cart) {
    var attr = cart && cart.attributes && cart.attributes.insuranceOptOut;
    if (attr === 'true') return false;
    if (attr === 'false') return true;
    try { return localStorage.getItem(OPT_IN_KEY) !== 'false'; } catch (e) { return true; }
  }

  function saveChoice(on) {
    try { localStorage.setItem(OPT_IN_KEY, String(on)); } catch (e) {}
  }

  function qtyOf(item, qtyByKey) {
    return Object.prototype.hasOwnProperty.call(qtyByKey, item.key) ? qtyByKey[item.key] : item.quantity;
  }

  function plan(cart, qtyByKey, want) {
    var result = { updates: {}, attributes: {} };
    var cfg = getConfig();
    if (!cart || !cart.items || !Object.keys(cfg).length) return result;
    qtyByKey = qtyByKey || {};

    var subtotal = 0;
    var itemCount = 0;
    var onlyGiftCard = true;
    var existing = [];
    cart.items.forEach(function (item) {
      var qty = qtyOf(item, qtyByKey);
      if (isProtection(item)) { existing.push(item); return; }
      if (qty <= 0) return;
      var unit = item.quantity ? item.line_price / item.quantity : 0;
      subtotal += Math.round(unit * qty);
      itemCount += qty;
      if (NO_PROTECTION_HANDLES.indexOf(item.handle) === -1) onlyGiftCard = false;
    });
    var giftCardOnly = itemCount === 1 && onlyGiftCard;

    var add = want && subtotal > 0 && !giftCardOnly;
    var handle = requiredHandle(subtotal);
    var tier = cfg[handle];
    var hasCorrect = false;

    existing.forEach(function (item) {
      if (add && tier && item.handle === handle && !hasCorrect) {
        hasCorrect = true;
        if (qtyOf(item, qtyByKey) !== 1) result.updates[item.key] = 1;
      } else if (qtyOf(item, qtyByKey) !== 0) {
        result.updates[item.key] = 0;
      }
    });
    if (add && tier && !hasCorrect) result.updates[tier.id] = 1;
    if (!giftCardOnly) result.attributes.insuranceOptOut = want ? 'false' : 'true';
    return result;
  }

  // True when the cart already matches the shopper's choice (nothing to send)
  function matches(cart) {
    var fix = plan(cart, {}, optedIn(cart));
    if (Object.keys(fix.updates).length) return false;
    var attr = (cart.attributes || {}).insuranceOptOut;
    return fix.attributes.insuranceOptOut === undefined || attr === fix.attributes.insuranceOptOut;
  }

  function subtotalOf(cart) {
    return cart.items.reduce(function (t, i) { return isProtection(i) ? t : t + i.line_price; }, 0);
  }

  function tierFor(cart) {
    return getConfig()[requiredHandle(subtotalOf(cart))] || null;
  }

  // Pages other than the cart don't carry the tier list (see the config snippet).
  // Resolves true when the tier this cart needs is known; false if it could not be loaded,
  // in which case the caller should leave Shipping Protection as it is.
  function loadTierFor(cart) {
    var handle = requiredHandle(subtotalOf(cart));
    var cfg = getConfig();
    if (cfg[handle]) return Promise.resolve(true);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        var variant = product && product.variants && product.variants[0];
        if (!variant) return false;
        cfg[handle] = { id: variant.id, price: variant.price };
        return true;
      })
      .catch(function () { return false; });
  }

  window.SteelProtection = {
    getConfig: getConfig,
    isProtection: isProtection,
    requiredHandle: requiredHandle,
    optedIn: optedIn,
    saveChoice: saveChoice,
    plan: plan,
    matches: matches,
    tierFor: tierFor,
    loadTierFor: loadTierFor
  };
})();
